import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// 🎯 FIX: Renamed to PascalCase to satisfy ESLint react/jsx-pascal-case
import WorkflowXls2SchemaView from "./Workflow_XLS_2_Schema_View.jsx";
import {
  GetInitialCycleState,
  executeWorkflowHandshake,
} from "./Workflow_XLS_Support";
import { GoldenSourceHelper } from "../../../../app/Switch_Core_React_Standards";

export default function WorkflowXls2SchemaController() {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [batches, setBatches] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [cycleData, setCycleData] = useState(GetInitialCycleState());

  useEffect(() => {
    async function load() {
      setIsSubmitting(true);
      const res = await executeWorkflowHandshake(
        "esg-taxonomy/workflows/completed-batches",
        null,
        "GET",
      );
      if (res.success) setBatches(res.data || []);
      setIsSubmitting(false);
    }
    load();
  }, []);

  const handleValidate = async (file) => {
    setSelectedFile(file);
    setIsSubmitting(true);

    // Wrap in data key to let prepareForApi handle unwrapping for ASP.NET
    const res = await executeWorkflowHandshake("bff/xls-to-schema/validate", {
      data: { s3Key: GoldenSourceHelper.get(file, "prefixedS3Key") },
    });

    if (res.success) {
      setPreviewData(res.data);
      setStep(2);
    }
    setIsSubmitting(false);
  };

  const handleSaveCycle = async () => {
    setIsSubmitting(true);

    // Build payload using GoldenSource casing-tolerant 'get'
    const payload = {
      data: {
        ...cycleData,
        BatchID: GoldenSourceHelper.get(selectedFile, "batchID"),
        SemanticTreeID:
          GoldenSourceHelper.get(previewData, "semanticTreeID") || 0,
        CycleID: 0,
      },
    };

    const res = await executeWorkflowHandshake(
      "sustina/workflows/esg-taxonomy/save-cycle",
      payload,
    );
    if (res.success) navigate("/registered/site-admin/taxonomy-workflow");
    setIsSubmitting(false);
  };

  /**
   * 🎯 FIXED: handleBack is now utilized as a prop to satisfy no-unused-vars
   */
  const handleBack = () => {
    if (step === 1) {
      // Navigate back to the Strategic Workflow Hub
      navigate("/registered/site-admin/taxonomy-workflow");
    } else {
      // Internal state reversal
      setStep((prev) => prev - 1);
    }
  };

  return (
    <WorkflowXls2SchemaView
      step={step}
      batches={batches}
      previewData={previewData}
      cycleData={cycleData}
      isSubmitting={isSubmitting}
      onValidate={handleValidate}
      onConfirmPreview={() => setStep(3)}
      onReject={() => setStep(1)}
      onCycleChange={(e) =>
        setCycleData({ ...cycleData, [e.target.name]: e.target.value })
      }
      onSave={handleSaveCycle}
      onBack={handleBack} 
    />
  );
}